class Perfil {
    constructor() {
        this.id = null;
        this.menu = '';
        this.url = '';
        this.perfilUrls = [];
    }
}

export default Perfil;